// unobtrusive_flash shows the flash cookie on every jQuery ajaxSuccess. Ahoy
// sends its events through $.ajax about a second after a page loads, so its
// POST can finish while Turbo is following a redirect, take that redirect's
// flash, and show it on the page being left. Ahoy's requests never carry a
// flash, so keep them out of jQuery's global ajax events.
export function keepAhoyRequestsOutOfGlobalEvents($, urls) {
  $.ajaxPrefilter((options) => {
    if (urls.includes(options.url)) {
      options.global = false;
    }
  });
}
